/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Scene_Description_Job_TitleInputs */



/**
* | output |
* | --- |
* | "Confirm Shot Description Job Submission" |
*
* @param {Confirm_Scene_Description_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_scene_description_job_title = /** @type {((inputs?: Confirm_Scene_Description_Job_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Scene_Description_Job_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer la description du plan Soumission de la tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigung der Schussbeschreibung für die Stellenbewerbung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma la descrizione dell'inquadratura Invio della candidatura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите описание снимка. Отправка заявки на вакансию.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar la descripción de la toma enviada para el trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认镜头描述工作提交")
	if (locale === "ja") return /** @type {LocalizedString} */ ("撮影内容の確認 求人応募")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट विवरण जॉब सबमिशन की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar descrição da cena e envio da vaga")
	return /** @type {LocalizedString} */ ("Confirm Shot Description Job Submission")
});